<template>
  <div class="animated-loader" />
</template>

<style lang="scss">
@use 'assets/scss/_variables/colors';
@import '../style/variables';

.animated-loader {
  position: relative;

  &::before,
  &::after {
    width: 1em;
    height: 1em;
    border-radius: 100%;
    content: '';
    position: absolute;
  }

  &::before {
    background: colors.$link-base-default;
    animation: xLoaderCrossingShapesBefore 1s infinite ease-in-out;
  }

  &::after {
    background: colors.$all-orange-60;
    left: 42px;
    animation: xLoaderCrossingShapesAfter 1s infinite ease-in-out;
  }
}

@keyframes xLoaderCrossingShapesBefore {
  0% { transform: translateX(0) rotate(0deg); }

  50% {
    transform: translateX(60px) scale(1.2) rotate(260deg);
    background: colors.$all-orange-60;
    border-radius: 84% 58% 91% 59% / 86% 75% 79% 58%;
  }
  100% { transform: translateX(0) rotate(0deg); }
}

@keyframes xLoaderCrossingShapesAfter {
  0% { transform: translateX(0); }

  50% {
    transform: translateX(-60px) scale(1.2) rotate(-260deg);
    background:  colors.$link-base-default;
    border-radius: 55% 45% 23% 77% / 61% 64% 36% 39%;
  }
  100% { transform: translateX(0); }
}
</style>
